import { useEffect, useState } from 'react';
import { MDSLNB, MDSLNBItem } from '@marqvision/mds-v2';
import { UseNavigationProps } from '@marqvision/shared';
import { useUserInfoQuery } from '~/apis/auth';
import { useSelectedBrandId } from '~/hooks';
import { MARQ_AI_LNB } from './@constants';
import { changeRouteName, getAllowedRoutes } from './@utils';

type Props = UseNavigationProps['lnbProps'];

export const LeftNavigationBar = (props: Props) => {
  const { data: userData } = useUserInfoQuery();
  const { brandId } = useSelectedBrandId();

  const [allowedRoutes, setAllowedRoute] = useState<MDSLNBItem[][]>([]);

  const newRoutes = changeRouteName(allowedRoutes ?? [], userData);

  useEffect(() => {
    const promises = MARQ_AI_LNB.map((item) => getAllowedRoutes(item, { brandId }));
    Promise.all(promises).then((res) => {
      setAllowedRoute(res);
    });
  }, [brandId]);

  return <MDSLNB {...props} list={newRoutes} />;
};
